import { RECEIVE_RESULTS } from '../actions/results';

export default function results(state=[], action) {
  switch(action.type) {
    case RECEIVE_RESULTS:
      return action.results
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/results.js